// Types — module Support (tickets & conversation)

import { createI18nLabelMap } from '../utils/i18n/getStatusLabel';

export type SupportTicketStatus = 'open' | 'waiting_client' | 'resolved';

export type SupportTicketCategory = 'bug' | 'question' | 'feature' | 'other';

export type SupportAuthorSide = 'client' | 'nauvatek';

export type SupportAttachmentType = 'image' | 'video';

export interface SupportTicketAttachment {
  type: SupportAttachmentType;
  url: string;
  storagePath: string;
  contentType: string;
  fileName: string;
  sizeBytes: number;
}

export interface SupportTicket {
  id: string;
  businessId: string;
  businessName: string;
  /** Employé / user métier qui voit le ticket dans Aide */
  createdByUserId: string;
  createdByName: string;
  /** Si ouvert par SA/CSM pour un employé */
  openedByUserId?: string;
  openedByName?: string;
  subject: string;
  category?: SupportTicketCategory;
  status: SupportTicketStatus;
  lastMessageAt: Date;
  lastMessagePreview: string;
  /** Auteur du dernier message (pour badge non lu côté client) */
  lastMessageAuthorSide?: SupportAuthorSide;
  /** Dernière fois que le client a ouvert la conversation */
  clientLastReadAt?: Date;
  /** Dernière fois que NauvaTek (SA/CSM) a ouvert la conversation */
  staffLastReadAt?: Date;
  /** Premier message NauvaTek (dénormalisé pour stats délai de prise en charge) */
  firstNauvatekReplyAt?: Date;
  createdAt: Date;
  updatedAt: Date;
  resolvedAt?: Date;
  resolvedByUserId?: string;
  mediaPurgeAt?: Date;
  /** true tant que la purge Storage n’a pas tourné */
  mediaPurgePending?: boolean;
  mediaPurgedAt?: Date;
}

export interface SupportTicketMessage {
  id: string;
  authorUserId: string;
  authorName: string;
  authorSide: SupportAuthorSide;
  body: string;
  attachments: SupportTicketAttachment[];
  createdAt: Date;
  mediaPurged?: boolean;
}

export const SUPPORT_TICKET_STATUS_LABELS: Record<SupportTicketStatus, string> = createI18nLabelMap(
  'supportTicketStatus',
  ['open', 'waiting_client', 'resolved'] as const
);

export const SUPPORT_TICKET_STATUS_COLORS: Record<SupportTicketStatus, string> = {
  open: 'orange',
  waiting_client: 'blue',
  resolved: 'green',
};

export const SUPPORT_TICKET_CATEGORY_LABELS: Record<SupportTicketCategory, string> = createI18nLabelMap(
  'supportTicketCategory',
  ['bug', 'question', 'feature', 'other'] as const
);

/** Délai de rétention des médias après clôture (jours). */
export const SUPPORT_MEDIA_RETENTION_DAYS = 10;

export const SUPPORT_MAX_IMAGE_BYTES = 8 * 1024 * 1024;
export const SUPPORT_MAX_VIDEO_BYTES = 40 * 1024 * 1024;
